import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { clientConfigAtom } from '@app/state/clientsAtom'
import { useAtomValue } from 'jotai'
import { formatLongCurrency } from '@app/utils/numbers.utils'

type SelectedElementInfoCardProps = {
  information?: Record<string, unknown>
  metadata?: Record<string, unknown> | null
}

export const SelectedElementInfoCard = ({
  information,
  metadata,
}: SelectedElementInfoCardProps) => {
  const clientConfig = useAtomValue(clientConfigAtom)

  return (
    <div className="w-1/3">
      <div className="w-full my-5 max-w-full mx-auto">
        <div className="grid grid-cols-1 gap-4">
          <div className="rounded-md border p-4 shadow-sm bg-white">
            <Tabs className="w-full" defaultValue="information">
              <TabsList className="w-full">
                <TabsTrigger className="w-1/2" value="information">
                  Information
                </TabsTrigger>
                <TabsTrigger className="w-1/2" value="metadata">
                  Metadata
                </TabsTrigger>
              </TabsList>
              {information && (
                <TabsContent className="text-sm" value="information">
                  <ul className="mt-5">
                    {Object.entries(information).map(([title, value], index) => {
                      if (title === 'Replacement Cost') {
                        value = formatLongCurrency(Number(value), clientConfig?.locale ?? 'en-NZ')
                      }
                      return (
                        <li
                          key={index}
                          className="mb-2 border-b-solid border-sidebar-border border-b-[1px] pb-2 flex"
                        >
                          <p className="w-1/2 font-[500]">{title}</p>
                          <p className="w-1/2">{value as React.ReactNode}</p>
                        </li>
                      )
                    })}
                  </ul>
                </TabsContent>
              )}
              {metadata && (
                <TabsContent className="text-sm" value="metadata">
                  <ul className="mt-5">
                    {Object.entries(metadata).map(([title, value], index) => {
                      if (title === 'group' || title === 'type') return
                      if (title === 'last_reviewer' && !value) value = 'None specified'

                      return (
                        <li
                          key={index}
                          className="mb-2 border-b-solid border-sidebar-border border-b-[1px] pb-2 flex"
                        >
                          <p className="w-1/2 font-[500] capitalize">{title.replace('_', ' ')}</p>
                          {title === 'source_link' ? (
                            <a
                              rel="noreferrer"
                              target="_blank"
                              className="text-rexBlue font-medium underline"
                              href={typeof value === 'string' ? value : '#'}
                            >
                              Link
                            </a>
                          ) : (
                            <p className="w-1/2">{value as React.ReactNode}</p>
                          )}
                        </li>
                      )
                    })}
                  </ul>
                </TabsContent>
              )}
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  )
}
